import { createSignal } from "solid-js"
import { isControlPlaneDashboardPath } from "@/utils/machine-route"

const FALLBACK_ROUTE = "/dashboard"
const [route, setRoute] = createSignal(FALLBACK_ROUTE)

/**
 * Last workspace route the user viewed before opening a control page
 * (Settings, Providers, Tools). Control pages return here instead of the
 * dashboard root, so hopping between control pages never loses the origin.
 */
export const workspaceReturnRoute = route

export function rememberWorkspaceRoute(pathname: string, search = "") {
  if (isControlPlaneDashboardPath(pathname)) return
  setRoute(`${pathname}${search}`)
}

export function resetWorkspaceReturnRoute() {
  setRoute(FALLBACK_ROUTE)
}
